module.exports = __webpack_public_path__ + "media/src/images/logos/gumroad-691c951415327a8ecc603328b75d1283.png";